import { render, staticRenderFns } from "./mod1CustomerChatLog.vue?vue&type=template&id=7494982d"
import script from "./mod1CustomerChatLog.vue?vue&type=script&lang=js"
export * from "./mod1CustomerChatLog.vue?vue&type=script&lang=js"
import style0 from "./mod1CustomerChatLog.vue?vue&type=style&index=0&id=7494982d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports